module.exports = __webpack_public_path__ + "media/images/emblems/Langnau_am_Albis-96ce8ab034126531065f24665ecd168e.svg";